'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Table: ()=>Table
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_Table_variants_cjs_namespaceObject = require("./Table.variants.cjs");
const external_Table_context_cjs_namespaceObject = require("./Table.context.cjs");
const external_cleanTableProps_cjs_namespaceObject = require("../cleanTableProps.cjs");
const index_cjs_namespaceObject = require("../../../utils/index.cjs");
const external_LoadingSpinner_cjs_namespaceObject = require("../LoadingSpinner.cjs");
function Table({ children, className, ...props }) {
    const [placeholder, setPlaceholder] = (0, external_react_namespaceObject.useState)(false);
    const [maxColumns, setMaxColumns] = (0, external_react_namespaceObject.useState)(0);
    const { scrollable, scrollClassName = 'h-50 w-4xl' } = props;
    const styles = (0, external_Table_variants_cjs_namespaceObject.tableVariants)(props);
    const cleanedProps = (0, external_cleanTableProps_cjs_namespaceObject.cleanTableProps)(props);
    const containerClassName = (0, index_cjs_namespaceObject.cn)(styles.container(), scrollable ? scrollClassName : '');
    const tableRef = (0, external_react_namespaceObject.useRef)(null);
    const contextValue = (0, external_react_namespaceObject.useMemo)(()=>({
            ...props,
            placeholder,
            setPlaceholder,
            maxColumns,
            setMaxColumns
        }), [
        props,
        placeholder,
        maxColumns
    ]);
    const tableSize = (0, external_react_namespaceObject.useMemo)(()=>{
        const tableSizes = {};
        if (tableRef.current) {
            const tableElement = tableRef.current;
            const tHeadElement = tableElement.tHead;
            const container = tableElement.parentElement;
            tableSizes['--table-width'] = (props.scrollable ? container?.offsetWidth : tableElement?.offsetWidth) ?? 0;
            tableSizes['--table-height'] = (props.scrollable ? container?.offsetHeight : tableElement?.offsetHeight) ?? 0;
            tableSizes['--table-head-height'] = tHeadElement?.offsetHeight ?? 0;
        }
        return tableSizes;
    }, [
        tableRef.current,
        tableRef?.current?.offsetHeight,
        tableRef?.current?.tHead?.offsetHeight,
        tableRef?.current?.offsetWidth,
        props.headerSticky,
        props.scrollable
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Table_context_cjs_namespaceObject.TableContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
            className: "relative",
            style: {
                ...tableSize
            },
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: containerClassName,
                    ...cleanedProps,
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("table", {
                        className: (0, index_cjs_namespaceObject.cn)(styles.base(), className),
                        ref: tableRef,
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_LoadingSpinner_cjs_namespaceObject.LoadingSpinner, {
                    loading: props.loading,
                    scrollable: scrollable,
                    colSpan: maxColumns,
                    headerSticky: props.headerSticky
                })
            ]
        })
    });
}
exports.Table = __webpack_exports__.Table;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Table"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
